import React from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'
import { createStore, applyMiddleware, compose } from 'redux'
import createSagaMiddleware from 'redux-saga'

// Import application styles
import '../styles.js'

import { SessionStorage } from './Core'

import rootReducer from './reducers'
import rootSaga from './sagas'
import Root from './root'

console.log('NODE_ENV', process.env.NODE_ENV)

Sentry.init({
  dsn: 'https://8ad04636d3034e4da09df4c70dbb5192@o436063.ingest.sentry.io/5502567',
  environment: process.env.NODE_ENV,
  integrations: [new Integrations.BrowserTracing({ logErrors: true })],
})

const isProduction =
  process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'preproduction'

// Creating store
let store = null
const sagaMiddleware = createSagaMiddleware()
const middleware = applyMiddleware(sagaMiddleware)

if (isProduction) {
  store = createStore(rootReducer, middleware)
} else {
  let enhancer

  // Enable DevTools if browser extension is installed
  if (window.__REDUX_DEVTOOLS_EXTENSION__) { // eslint-disable-line
    enhancer = compose(
      middleware,
      window.__REDUX_DEVTOOLS_EXTENSION__() // eslint-disable-line
    )
  } else {
    enhancer = compose(middleware)
  }

  store = createStore(rootReducer, enhancer)
}

// Monkeypatch SessionStorage
SessionStorage.initSessionStorage()

// Connect sagas to store
sagaMiddleware.run(rootSaga)

/**
 *  Main entry point.
 */
function runApp() {
  const container = document.getElementById('main')
  const root = createRoot(container)
  root.render(<Root store={store} />)
}

runApp()
